import React from 'react';
import MUIButton from '@mui/material/Button';

import { Props } from './types';

const Button = (props: Props) => {
  const { children, sx, colorScheme = 'primary', variant = 'contained' } = props;

  const colorSchemeObj = React.useMemo(() => {
    if (colorScheme === 'primary') {
      return {
        color: 'common.white',
        backgroundColor: 'primary.main',
        '&:hover': { backgroundColor: 'primary.main' },
      };
    } else if (colorScheme === 'primary-lighter') {
      return {
        color: 'primary.main',
        backgroundColor: 'primary.lighter',
        '&:hover': { backgroundColor: 'primary.lighter' },
      };
    } else if (colorScheme === 'custom-outlined-white') {
      return {
        boxShadow: 'none',
        backgroundColor: 'common.white',
        color: 'mist.contrast70',
        border: '1px solid',
        borderColor: 'mist.contrast70',
        '&:hover': { backgroundColor: 'common.white', color: 'mist.contrast70' },
      };
    }
    return {};
  }, [colorScheme]);

  const propsCopy = { ...props };
  delete propsCopy.colorScheme;

  return (
    <MUIButton
      {...propsCopy}
      variant={variant}
      sx={{
        borderRadius: 14,
        textTransform: 'none',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'block',
        ...colorSchemeObj,
        ...sx,
      }}
    >
      {children}
    </MUIButton>
  );
};

export default Button;
